import {useEffect, useState} from "react";
import {browserPushConfig, browserPushStatus, browserPushSupported, disableBrowserPush, enableBrowserPush,
  testBrowserPush, type BrowserPushConfig, type BrowserPushStatus} from "./browserPush";

export function BrowserPushOptIn({sessionUserId}: {sessionUserId: string}) {
  const [config, setConfig] = useState<BrowserPushConfig>({enabled: false});
  const [status, setStatus] = useState<BrowserPushStatus>({registered: false, version: 0});
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    let cancelled = false;
    setStatus({registered: false, version: 0}); setMessage("");
    if (!browserPushSupported()) return;
    void browserPushConfig().then(async (value) => {
      if (cancelled) return;
      setConfig(value);
      if (value.enabled) { const current = await browserPushStatus(); if (!cancelled) setStatus(current); }
    }).catch(() => { if (!cancelled) setMessage("Фоновые уведомления временно недоступны."); });
    return () => { cancelled = true; };
  }, [sessionUserId]);
  async function run(action: "enable" | "disable" | "test" | "refresh") {
    setBusy(true); setMessage("");
    try {
      const result = action === "enable" ? await enableBrowserPush(config) : action === "disable" ? await disableBrowserPush() :
        action === "test" ? await testBrowserPush(status.version) : await browserPushStatus();
      setStatus(result);
      setMessage(action === "test" ? "Проверка поставлена в очередь. Нажмите «Проверить получение» после появления уведомления." : "");
    } catch (error) { setMessage(error instanceof Error ? error.message : "Не удалось изменить уведомления."); }
    finally { setBusy(false); }
  }
  if (!browserPushSupported()) return <p className="muted">Этот браузер не поддерживает фоновые уведомления. Новые документы видны внутри программы.</p>;
  if (!config.enabled) return <p className="muted">Фоновые уведомления пока не подключены. Новые документы видны внутри программы.</p>;
  const received = status.lastDelivery?.status === "acknowledged";
  return <section aria-label="Фоновые уведомления браузера">
    <p>{status.registered ? "Уведомления включены до завершения текущего сеанса." : "Разрешите браузеру сообщать о новых документах, даже когда вкладка закрыта."}</p>
    <div className="toolbar-actions">
      {status.registered ? <>
        <button type="button" disabled={busy} onClick={() => void run("test")}>Проверить уведомление</button>
        <button type="button" disabled={busy} onClick={() => void run("refresh")}>Проверить получение</button>
        <button type="button" disabled={busy} onClick={() => void run("disable")}>Выключить</button>
      </> : <button type="button" disabled={busy} onClick={() => void run("enable")}>Включить уведомления</button>}
    </div>
    <p role="status" aria-live="polite">{message || (received ? "Браузер подтвердил показ уведомления." :
      status.lastDelivery?.status === "sent" ? "Сервис принял уведомление; получение браузером ещё не подтверждено." :
      status.lastDelivery?.status === "pending" ? "Уведомление ожидает отправки." :
      status.lastDelivery?.status === "failed" || status.lastDelivery?.status === "suppressed" ?
        "Уведомление не доставлено. Проверьте подключение или включите уведомления заново." : "")}</p>
  </section>;
}
